angular.module('impactx.purchaserequest').controller('PurchaseRequestListReadOnlyCtrl', [
    '$redirect',
    'dataGen',
    'selectedListItems',
    '$mdDialog',
    'ToastService',
    'CancellationService',
    PurchaseRequestListReadOnlyCtrl]);

function PurchaseRequestListReadOnlyCtrl($redirect, dataGen, selectedListItems, $mdDialog, ToastService, CancellationService) {
    
    var ctrl = this;

    ctrl.getDetailLink = function () {
        return "purchaserequestdetail/"+ selectedListItems.getFirstSelectedItem().id;
    };

    ctrl.canCancel = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCancel.value;
    };

    ctrl.cancelItems = function() {
        var selected = [];
        angular.forEach(selectedListItems.getSelectedIds(), function(id){
            selected.push({prhId: id});
        });
        CancellationService.cancelItems(event, selected);
    };

    ctrl.cancelAll = function(event) {
        var selected = [];

        angular.forEach(selectedListItems.getSelectedIds(), function(id){
            selected.push({prhId: id});
        });
        CancellationService.cancelAll(event, selected);
    };

    ctrl.sendDeliveryReminder = function () {
        dataGen.postAsForm({}, {prhIds: selectedListItems.getSelectedIds()}, "/deliverynote/remind").then(function (data) {
            if(data && data.data)
            {
                if (data.data.failedNumbers.length > 0)
                {
                    $mdDialog.show({
                        controller: 'DeliveryNoteReminderResultCtrl',
                        controllerAs: 'ctrl',
                        locals: {
                            successMessage: data.data.success,
                            failedMessage: data.data.failed,
                            failedNumbers: data.data.failedNumbers,
                            trns: data.trns
                        },
                        templateUrl: 'modules/deliverynote/templates/deliverynote-reminder.result.tmpl.html',
                        parent: angular.element(document.body),
                        bindToController: true
                    });
                }
                else
                {
                    ToastService.openStandardToast(data.data.success);
                }
            }
        });
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'PurchaseRequestView'},
        {label: "cancel", action: ctrl.cancelItems, condition: ctrl.canCancel, process: 'Cancellation'},
        {label: "cancelAll", action: ctrl.cancelAll, condition: ctrl.canCancel, process: 'Cancellation'},
        {label: "sendDeliveryReminder", action: ctrl.sendDeliveryReminder, condition: selectedListItems.isMultiSelection, process: 'RemindDeliveryNote'}
    ];

    this.meta = {
        rowTemplate: 'modules/status/purchaserequest/templates/purchaserequestlistreadonly.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/purchaserequest/listreadonly',
        ctrl: this,
        id: "purchaserequestlistreadonly",
        buttonDefinition: buttonDefinition
    };
    
    this.getMeta = function () {
        return this.meta;
    };

}
